import { PlanBenchmarkButton } from '../features/plan-benchmark/PlanBenchmarkButton';

type Props = { planId: string };

export const PlanBenchmarkApp: React.FC<Props> = ({ planId: _planId }) => <PlanBenchmarkButton />;

PlanBenchmarkApp.displayName = 'PlanBenchmarkApp';
